<ctx-page-header [activatedRoute]="route.snapshot"></ctx-page-header>
<ctx-table-filter [resourceTableService]="license"></ctx-table-filter>
<ctx-paginated-table [resourceTableService]="license"></ctx-paginated-table>
